
  export default {
    mounted() {
      const isPanelsVisible = this.el.getAttribute("data-panels-visible") === "true";
      this.panelIndex = Number(this.el.getAttribute("data-panel-index"));
      const currentPanelIndex = Number(this.el.getAttribute("data-current-panel-index"));
      const videoId = this.el.getAttribute("data-video-id")
      this.video = document.getElementById(videoId)

      if (!isPanelsVisible || this.panelIndex != currentPanelIndex) {
        this.el.classList.add("hidden")
      }

      this.handleSoundChange = (event) => {
        const detail = event && event.detail;
        if (detail && typeof detail.sound_on === "boolean") {
          this.applyMutedState(detail.sound_on);
          return;
        }

        this.applyMutedState();
      };

      this.applyMutedState();

      if (typeof window !== "undefined") {
        window.addEventListener("zulti:sound-state-changed", this.handleSoundChange);
      }
    },
    destroyed() {
      if (typeof window !== "undefined" && this.handleSoundChange) {
        window.removeEventListener("zulti:sound-state-changed", this.handleSoundChange);
      }
    },
    updated() {
      const isPanelsVisible = this.el.getAttribute("data-panels-visible") === "true";
      const currentPanelIndex = Number(this.el.getAttribute("data-current-panel-index"));

      if (isPanelsVisible && this.panelIndex === currentPanelIndex) {
        this.el.classList.remove("hidden")

        if (this.video) {
          this.applyMutedState();
          this.video.play().catch(() => {})
        }

        return
      }

      this.el.classList.add("hidden")

      if (this.video) {
        this.video.pause()
        this.video.currentTime = 0
      }
    },
    applyMutedState(soundOnFromEvent) {
      if (!this.video) {
        return;
      }

      let soundOn = soundOnFromEvent;

      if (typeof soundOn === "undefined") {
        try {
          const stored = typeof window !== "undefined" ? window.localStorage.getItem("soundEnabled") : null;
          soundOn = stored !== "false";
        } catch (_error) {
          soundOn = true;
        }
      }

      this.video.muted = !soundOn;
    }
  }
